import React from 'react';
import { TableContainer } from '../styles';
import moment from 'moment';
import { CiEdit } from 'react-icons/ci';
import { RiDeleteBinLine } from 'react-icons/ri';
import lu from '@app/assets/images/lu.png';

const FactsTable = ({ facts, handleDelete, handleEdit }) => {
  const head = ['Title', 'Body', 'Date', ''];
  return (
    <TableContainer>
      <table>
        <thead>
          <tr>
            {head.map((data, idx) => (
              <th key={idx}>{data}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {facts.map((data) => (
            <tr key={data._id}>
              <td style={{ display: 'flex', alignItems: 'center', gap: '26px' }}>
                {data.image ? (
                  <img src={data.image} alt={data.title} />
                ) : (
                  <img src={lu} alt="lu_icon" />
                )}

                <h4>{data.title}</h4>
              </td>
              <td>{data.body.slice(0, 50)}...</td>
              <td>{moment(data.created_at).format('LL')}</td>
              <td>
                <div style={{ display: 'flex', alignItems: 'center', gap: '26px' }}>
                  <CiEdit size={18} onClick={() => handleEdit(data)} />
                  <RiDeleteBinLine
                    size={18}
                    onClick={() => handleDelete(data._id)}
                  />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </TableContainer>
  );
};

export default FactsTable;
